<template>
  <div class="faq-area with-top-border ptb-100">
    <div class="container">
      <div class="row m-0 align-items-end">
        <div class="col-lg-6 col-md-12 p-0">
          <div class="faq-accordion">
            <div class="section-title">
              <span class="sub-title">Perguntas Frequentes</span>
              <h2>Tire suas dúvidas sobre nossos serviços</h2>
            </div>
            <div class="accordion" id="faqAccordion">
              <div class="accordion-item" data-aos="fade-up" data-aos-duration="1200">
                <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                  Vocês desenvolvem para iOS e Android?
                </button>
                <div id="collapseOne" class="accordion-collapse collapse show" data-bs-parent="#faqAccordion">
                  <div class="accordion-body">
                    <p>Sim! Desenvolvemos aplicativos nativos para iOS e Android, além de aplicações híbridas usando Flutter e React Native. Garantimos experiência otimizada para cada plataforma.</p>
                  </div>
                </div>
              </div>
              <div class="accordion-item" data-aos="fade-up" data-aos-duration="1200" data-aos-delay="100">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                  Fazem integração com sistemas existentes?
                </button>
                <div id="collapseTwo" class="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                  <div class="accordion-body">
                    <p>Absolutamente! Especializamos em integrar novos sistemas com ERPs, CRMs, APIs de terceiros e bancos de dados existentes. Garantimos que tudo funcione em harmonia.</p>
                  </div>
                </div>
              </div>
              <div class="accordion-item" data-aos="fade-up" data-aos-duration="1200" data-aos-delay="200">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                  Trabalham com e-commerce?
                </button>
                <div id="collapseThree" class="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                  <div class="accordion-body">
                    <p>Sim! Desenvolvemos lojas virtuais completas com carrinho de compras, pagamentos online, gestão de estoque, cupons de desconto e integração com marketplaces como Mercado Livre.</p>
                  </div>
                </div>
              </div>
              <div class="accordion-item" data-aos="fade-up" data-aos-duration="1200" data-aos-delay="300">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                  Oferecem hospedagem e domínio?
                </button>
                <div id="collapseFour" class="accordion-collapse collapse" data-bs-parent="#faqAccordion">
                  <div class="accordion-body">
                    <p>Sim! Cuidamos de toda a infraestrutura: registro de domínio, hospedagem otimizada, SSL, backups automáticos e monitoramento 24/7 para garantir que seu sistema esteja sempre online.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-12 p-0">
          <div class="faq-image" data-aos="fade-up">
            <img src="../../assets/images/faq1.png" alt="faq-image">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Faq',
}
</script>